import React, { useState } from 'react';
import { NumberWithUnitInput } from 'components/common';
import OptionRowFloatInfr from 'components/layout/options/OptionRowFloatInfr.jsx';
import { readStoredFormulaOptions } from 'components/show_drawing/redraw_form/combo_local_storage.js';
import styles from 'components/show_drawing/redraw_form/_style.module.scss';

const CUSTOM = 'custom';

const defaultCustomThicknessForUnit = (unit) => {
  if (unit === 'in')   { return 0.0394; }
  if (unit === 'infr') { return '0+1/4'; }
  return 1;
};

const normalizeStored = (value) => (value == null || value === '') ? null : value;

const CustomThicknessInput = ({ name, unit, value, onChange, register, errors }) => {
  if (unit === 'infr') {
    return (
      <OptionRowFloatInfr
        item={{}}
        description=""
        name={name}
        value={value}
        unit={unit}
        abc_line=""
        onChange={onChange}
        onKeyUp={() => {}}
        wide={false}
        doNotLoadFromLocalStorage={true}
        disabled={false}
        decreaseNum={() => {}}
      />
    );
  }

  return (
    <NumberWithUnitInput
      name={name}
      unit={unit}
      placeholder=""
      register={register}
      class_name=""
      errors={errors}
      validators={[]}
      value={value}
      onChange={onChange}
    />
  );
};

const ComboGuestMaterialChooser = ({ relation, unit, register, errors, setRedrawRequested, drawingMainId }) => {
  const materials = (relation.materials && relation.materials.groups) || [];
  const askCustomMaterial = relation.materials && relation.materials.ask_custom_material;
  const defaultMaterialId = relation.materials && relation.materials.default_material_id;

  const stored = readStoredFormulaOptions(drawingMainId, unit) || {};
  const storedMaterialId = normalizeStored(stored[`combo_materials[${relation.id}][material_id]`]);
  const storedCustomThickness = normalizeStored(stored[`combo_materials[${relation.id}][custom_material_value]`]);

  const [materialId, setMaterialId] = useState(
    storedMaterialId !== null
      ? String(storedMaterialId)
      : (defaultMaterialId ? String(defaultMaterialId) : '')
  );
  const [customThickness, setCustomThickness] = useState(
    storedCustomThickness !== null
      ? storedCustomThickness
      : defaultCustomThicknessForUnit(unit)
  );

  if (materials.length === 0 && !askCustomMaterial) { return null; }

  const materialFieldName = `combo_materials[${relation.id}][material_id]`;
  const customFieldName = `combo_materials[${relation.id}][custom_material_value]`;

  const handleMaterialChange = (e) => {
    setMaterialId(e.target.value);
    setRedrawRequested(() => true);
  };

  const handleCustomChange = (e) => {
    setCustomThickness(e.target.value);
  };

  return (
    <>
      <div className={styles.row}>
        <div className="input-group" style={{ width: '100%' }}>
          <span
            className={`d_input_add_on input-group-addon input-group-addon-${window.locale} ${styles.input_add_on}`}
          >
            {t('drawing.material')}
          </span>
          <select
            id={`combo_material_${relation.id}`}
            name={materialFieldName}
            value={materialId}
            onChange={handleMaterialChange}
            className="form-control"
          >
            {materials.map((group) => (
              <optgroup label={group.group_name} key={group.group_name}>
                {group.materials.map((material) => (
                  <option key={material.id} value={material.id}>{material.name}</option>
                ))}
              </optgroup>
            ))}
            {askCustomMaterial && (
              <optgroup key="ask_custom_material">
                <option value={CUSTOM}>{t('drawing.enter_custom_material')}</option>
              </optgroup>
            )}
          </select>
        </div>
      </div>

      {materialId === CUSTOM && (
        <div
          className={styles.row}
          onBlur={(e) => {
            if (!e.currentTarget.contains(e.relatedTarget)) {
              setRedrawRequested(() => true);
            }
          }}
        >
          <div className="input-group" style={{ width: '100%' }}>
            <span
              className={`d_input_add_on input-group-addon input-group-addon-${window.locale} ${styles.input_add_on}`}
            >
              {t('drawing.custom_material_value')}
            </span>
            <div style={{ flex: 1 }}>
              <CustomThicknessInput
                name={customFieldName}
                unit={unit}
                value={customThickness}
                onChange={handleCustomChange}
                register={register}
                errors={errors}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ComboGuestMaterialChooser;
